import {
  type BrandVariants,
  type Theme,
  createLightTheme,
  createDarkTheme,
} from "@fluentui/react-components";

// TODO(klepierre-brand): Replace with the official Klepierre brand ramp once design provides
// the 16-step Fluent UI v9 brand variant table. Currently using a neutral corporate blue
// (#0078d4 family) as a sensible placeholder.
const brieftakerBrand: BrandVariants = {
  10: "#020305",
  20: "#111A2B",
  30: "#16314F",
  40: "#194069",
  50: "#1B5084",
  60: "#1C61A0",
  70: "#1B72BC",
  80: "#1884D9",
  90: "#3996E2",
  100: "#54A6E7",
  110: "#6CB6EC",
  120: "#84C6F1",
  130: "#9DD5F6",
  140: "#B5E4FA",
  150: "#CDF0FD",
  160: "#E5F9FF",
};

export const brieftakerLightTheme: Theme = createLightTheme(brieftakerBrand);
export const brieftakerDarkTheme: Theme = createDarkTheme(brieftakerBrand);
